export class AddCandidate {
    constructor() {
        this.firstName;
        this.lastName;
        this.emailId;
        this.phoneNumber;
        this.companyId;
        this.jobId;
    }
}
//# sourceMappingURL=addCandidate.js.map